'use client'

import { useLabels } from 'labels/hooks/useLabels/useLabels'
import { ProductDisclaimer } from 'product/types/Product'
import { cx } from 'utils/cx'

import styles from './SizeDisclaimer.module.scss'
import text from 'fukku/styles/texts.module.scss'

const sizeDisclaimerKey = {
	[ProductDisclaimer.UP_DISCLAIMER]:
		'product.sizeSelector.smallSizing.helpmessage',
	[ProductDisclaimer.DOWN_DISCLAIMER]:
		'product.sizeSelector.bigSizing.helpmessage',
	[ProductDisclaimer.SIZEGUIDE_DISCLAIMER]:
		'product.sizeSelector.helpSize.sizeguide.text',
	[ProductDisclaimer.MATERNITY_DISCLAIMER]:
		'product.sizeSelector.helpSize.maternity.text',
}

interface SizeDisclaimerProps {
	disclaimer?: ProductDisclaimer
	className?: string
}

export function SizeDisclaimer({
	disclaimer,
	className,
}: SizeDisclaimerProps): React.ReactNode {
	const { t } = useLabels()

	return disclaimer ? (
		<div className={cx(styles.sizeDisclaimer, text.bodyS, className)}>
			{t(sizeDisclaimerKey[disclaimer])}
		</div>
	) : null
}
